<template>
  <div class="canvas-box">
    <canvas
      :id="`label-canvas${idKey}`"
      :width="`${width}px`"
      :height="`${height}px`"
    >
    </canvas>
    <div
      class="tip-box"
      ref="tip"
      :style="{ left: tipLeft + 'px', top: tipTop + 'px' }"
      v-show="showTip"
    >
      <div class="top-angle" v-show="isTop"></div>
      <div class="content" @touchstart="changeLock">
        <div v-for="pointer in showPointer" :key="pointer.pid">
          <div class="top">
            <div class="username">{{ pointer.userName }}</div>
            <div class="text">标记的内容{{ pointer.userName ? "：" : "" }}</div>
            <div class="businessAffirm" v-if="pointer.businessAffirm">
              需业务员回复
            </div>
          </div>
          <div class="info">{{ pointer.content }}</div>
          <template v-if="pointer.businessReply">
            <div class="top">
              <div class="username">{{ pointer.businessUserName }}</div>
              <div class="text">回复的内容：</div>
            </div>
            <div class="info">{{ pointer.businessReply }}</div>
          </template>
        </div>
      </div>
      <div class="bot-angle" v-show="!isTop"></div>
    </div>
  </div>
</template>

<script>
import { fabric } from "fabric";
export default {
  /**
   * @param drawingList - 图纸列表
   * @param fabricObj - canvas对象
   * @param imageData - 标注的图纸
   * @param flag - 点击画布添加标注点的开关
   * @param top - 标注输入框的top定位
   * @param left - 标注输入框的left定位
   * @param  annotationList - 标注列表
   */
  data() {
    return {
      // width: 700,
      // height: 525,
      drawingList: [],
      fabricObj: "",
      // imageData: require("@/assets/iiimg/22.jpg"),
      imageData: "",

      top: 0,
      left: 0,
      annotationList: [],
      uid: "",
      commentList: [],
      index: 0,
      jumpInx: null,
      imgRemove: 0,
      showTip: false,
      tipLeft: 0,
      firstImg: 0,
      lastImg: 4,
      markFlag: false,
      drawId: "",
      dialogInfo: {
        dialogVisible: false,
      },
      circle: undefined,
      test: "",
      rightFill: "#000",
      leftFill: "#dbdbdb",
      dialogQuit: {
        dialogVisible: false,
      },
      quitFlag: false,
      quitType: "",
      addid: 1,
      isTop: "",
      tipTop: false,
      showPointer: [],
      canvasHeight: document.documentElement.clientHeight - 110,
      lockinit: true,
    };
  },
  props: {
    taggingimg: String,
    pointerList: Array,
    idKey: {
      default: 999,
    },
    isHandle: { default: true },
    isShow: { default: false },
    width: {
      default: 700,
    },
    height: {
      default: 525,
    },
    flag: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    taggingimg: {
      handler(val) {
        if (val) {
          this.imageData = val;
          this.fabricCanvas();
        }
      },
      immediate: true,
    },
    isHandle: {
      handler(val) {
        this.handleSetfabricOnDown();
      },
    },
    pointerList: {
      handler(val) {
        if (this.lockinit && val) {
          this.lockinit = false;
          // setTimeout(() => {
          //   this.getpointerList();
          // }, 100)
          this.$nextTick(() => {
            this.getpointerList();
          });
        }
      },
    },
  },
  computed: {
    isflog() {
      return this.flag;
    },
  },
  methods: {
    changeLock() {
      this.$emit("changeLock");
    },
    // 渲染所有点
    async getpointerList() {
      let multiple = parseInt(this.canvasHeight) / 600;
      this.pointerList.forEach((item) => {
        let circle = new fabric.Circle({
          pid: item.pid ? item.pid : "",
          userId: item.userId ? item.userId : "",
          top: parseInt(item.y * multiple) - 8,
          left: parseInt(item.x * multiple) - 8,
          radius: 8, // 圆的半径 30
          fill: "#DBDBDB",
          stroke: "#ffffff", // 边框原色
          borderColor: "rgba(0,0,0,0)",
          strokeWidth: 2, // 边框大小
          strokeWidth: 2, // 边框大小
          lockMovementX: true,
          lockMovementY: true,
          lockScalingX: true,
          lockScalingY: true,
        });
        circle.setControlsVisibility({
          mt: false,
          mb: false,
          ml: false,
          mr: false,
          bl: false,
          br: false,
          tl: false,
          tr: false,
          mtr: false,
        });
        circle.hoverCursor = "pointer";
        this.handleSetCircleOn(circle); //添加点击
        this.fabricObj.add(circle);
      });
    },
    // 渲染图纸
    fabricCanvas() {
      if (this.fabricObj) {
        // 如果画布已经存在，清空画布重新绘制
        this.fabricObj.clear();
      } else {
        this.fabricObj = new fabric.Canvas(`label-canvas${this.idKey}`, {
          // 此处设置画布的初始属性
          backgroundVpt: false,
          selection: false,
        });
      }
      this.markFlag = true;
      const image = new Image();
      image.src = this.imageData;
      image.onload = () => {
        let newWidth = 0;
        let newHeight = 0;
        if (image.width <= image.height) {
          let multiple = this.fabricObj.height / image.height;
          newWidth = parseInt(image.width * multiple);
          this.left = this.fabricObj.width / 2 - newWidth / 2;
          this.top = 0;
        } else {
          let multiple = this.fabricObj.width / image.width;
          newHeight = parseInt(image.height * multiple);
          this.top = this.fabricObj.height / 2 - newHeight / 2;
          this.left = 0;
        }
        let that = this;
        fabric.Image.fromURL(this.imageData, (imgObj) => {
          if (this.top != 0) {
            imgObj.scaleToWidth(that.fabricObj.width);
          } else if (this.left) {
            imgObj.scaleToHeight(that.fabricObj.height);
          }
          // that.fabricObj.add(imgObj);
          that.fabricObj.setBackgroundImage(
            imgObj,
            that.fabricObj.renderAll.bind(that.fabricObj),
            {
              opacity: 1,
              strech: true,
              top: this.top,
              left: this.left,
            }
          );
        });
        this.$nextTick(() => {
          this.fabricObj.renderAll(); // 重新渲染画布
        });
      };
      this.fabricObj.selectionBorderColor = "rgba(0,0,0,0)";
      this.handleSetfabricOnDown();
    },
    /**
     * @description 保存按钮
     * @param {*} inx - 点击元素的下标
     */
    /**
     * @description 删除按钮
     * @param {*} inx - 点击元素的下标
     */
    async deleteAnno(id) {
      const circle = this.fabricObj.getActiveObject();
      let objects = this.fabricObj.getObjects();
      if (circle != null) {
        if (circle.pid == id && circle) {
          this.fabricObj.discardActiveObject();
        }
      }

      for (var i = 0; i < objects.length; i++) {
        if (objects[i].pid == id) {
          this.fabricObj.remove(objects[i]);
          break;
        }
      }
    },
    // 选中
    selectAnno(id) {
      const circle = this.fabricObj.getActiveObject();
      let objects = this.fabricObj.getObjects();
      if (circle != null) {
        if (circle.pid == id && circle) {
          this.fabricObj.discardActiveObject();
        }
      }
      for (var i = 0; i < objects.length; i++) {
        if (objects[i].pid == id) {
          this.fabricObj.setActiveObject(objects[i]);
          break;
        }
      }
      this.fabricObj.renderAll();
    },
    /**
     * @description 标注点的选中事件
     * @param {*} circle - 标注点
     */
    handleSetCircleOn(circle) {
      let that = this;

      circle.on("selected", function (val) {
        val.target.set({ fill: "#3F996C" });
        that.$emit("selectItem", val.target);

        if (that.isShow) {

          that.getShowPointer(val.target.pid);
          const tip = that.$refs.tip;
          that.showTip = true;
          that.$nextTick(() => {
            that.tipLeft = val.target.left - 2;
            // 通过top位置判断弹出框向上或是向下展示
            if (val.target.top > 245) {
              that.isTop = false;
              that.tipTop = val.target.top - tip.scrollHeight - 10;
            } else {
              that.isTop = true;
              that.tipTop = val.target.top + 28;
            }
          });
        }
        that.fabricObj.off("mouse:up");
        that.fabricObj.off("mouse:down");
      });
      circle.on("deselected", function (val) {
        that.showTip = false;
        that.$emit("deselected", val.target.pid);
        val.target.set({ fill: "#DBDBDB" });
        that.handleSetfabricOnDown();
      });
    },
    // 取消选中
    noPointer() {
      this.fabricObj.discardActiveObject();
    },
    // 设置文本
    setMessage(index, message) {
      let objects = this.fabricObj.getObjects();
      objects[index].message = message;
    },
    // 通过pid拿到要展示的点的对象
    getShowPointer(pid) {
      let showList = [];
      this.pointerList.forEach((item) => {
        if (pid == item.pid) {
          showList.push(item);
        }
      });
      this.showPointer = JSON.parse(JSON.stringify(showList));

      this.recursion(showList);
    },
    // 递归相交圆
    recursion(lastList) {
      let showList = JSON.parse(JSON.stringify(lastList));
      const map = new Map();
      let _showList = [];
      // 保存要遍历的数组长度
      let length = showList.length;
      showList.forEach((out, index) => {
        this.pointerList.forEach((inside) => {
          // 判断圆心之间的距离，若小于直径，则加入数组
          let dis = Math.sqrt(
            (out.x - inside.x) * (out.x - inside.x) +
              (out.y - inside.y) * (out.y - inside.y)
          );
          if (dis < 18 && dis != 0) {
            showList.push(inside);
          }
          // 去重
          for (let item of showList) {
            if (!map.has(item.pid)) {
              map.set(item.pid, item);
            }
          }
          _showList = [...map.values()];
        });
        // 判断若为最后一次遍历，并且有相交的点则递归
        if (index == length - 1 && _showList.length != length) {
          this.showPointer = JSON.parse(JSON.stringify(_showList));
          this.recursion(_showList);
        }
      });
    },
    handleSetfabricOnDown() {
      this.fabricObj.on("mouse:down", (opt) => {
        this.$emit("touchStart", opt);
      });
      if (!this.isHandle) {
        return false;
      }
      let that = this;
      let canvas = this.fabricObj;
      let multiple = parseInt(this.canvasHeight) / 600;
      this.fabricObj.on("mouse:up", (opt) => {
        if (!this.isHandle) {
          return false;
        }
        // 鼠标按下时触发
        if (this.isflog) {
          this.quitFlag = true;
          let id = this.addid++;
          let circle = new fabric.Circle({
            top: opt.pointer.y - 8,
            left: opt.pointer.x - 8,
            radius: 8, // 圆的半径 30
            fill: "#DBDBDB",
            stroke: "#ffffff", // 边框原色
            borderColor: "rgba(0,0,0,0)",
            strokeWidth: 2, // 边框大小
            lockMovementX: true,
            lockMovementY: true,
            lockScalingX: true,
            lockScalingY: true,
            partName: "",
            partLength: "",
            partWidth: "",
            partHeight: "",
            partMaterial: "",
            partTech: "",
            pointer: true,
            pid: id,
            userId: this.$route.query.userId,
          });

          circle.setControlsVisibility({
            mt: false,
            mb: false,
            ml: false,
            mr: false,
            bl: false,
            br: false,
            tl: false,
            tr: false,
            mtr: false,
          });
          circle.hoverCursor = "pointer";
          this.handleSetCircleOn(circle);
          this.fabricObj.add(circle);
          this.$emit("addPart", {
            left: opt.pointer.x / multiple,
            top: opt.pointer.y / multiple,
            pid: id,
          });
          this.fabricObj.setActiveObject(circle);
        } else {
          this.$emit("isflog");
        }
      });

      // canvas.on("mouse:wheel", function (opt) {
      //   var delta = opt.e.deltaY;
      //   var zoom = canvas.getZoom();
      //   zoom *= 0.999 ** delta;
      //   if (zoom > 20) zoom = 20;
      //   if (zoom < 0.01) zoom = 0.01;

      //   canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
      //   fabric.Image.fromURL(that.imageData, (imgObj) => {
      //     if (that.top != 0) {
      //       imgObj.scaleToWidth(that.fabricObj.width);
      //     } else if (that.left) {
      //       imgObj.scaleToHeight(that.fabricObj.height);
      //     }
      //     that.fabricObj.setBackgroundImage(
      //       imgObj,
      //       that.fabricObj.renderAll.bind(that.fabricObj),
      //       {
      //         opacity: 1,
      //         strech: true,
      //         top: that.top * zoom,
      //         left: that.left * zoom,
      //       }
      //     );
      //   });
      //   opt.e.preventDefault();
      //   opt.e.stopPropagation();
      // });
      // canvas.on("mouse:down", function (opt) {
      //   var evt = opt.absolutePointer;
      //   if (opt.e.altKey === true) {
      //     this.isDragging = true;

      //     this.lastPosX = evt.x;
      //     this.lastPosY = evt.y;
      //   }
      //   this.selection = false;
      // });
      // canvas.on("mouse:move", function (opt) {
      //   if (this.isDragging) {
      //     var e = opt.absolutePointer;
      //     var vpt = this.viewportTransform;
      //     vpt[4] += e.x - this.lastPosX;
      //     vpt[5] += e.y - this.lastPosY;
      //     this.requestRenderAll();
      //     this.lastPosX = e.x;
      //     this.lastPosY = e.y;
      //     this.selection = true;
      //   }
      // });
      //   canvas.on("mouse:up", function (opt) {
      //     this.setViewportTransform(this.viewportTransform);
      //     this.isDragging = false;
      //     if (!this.selection) {
      //       if (this.flag || true) {
      //         this.flag = false;
      //         this.quitFlag = true;
      //         let id = this.addid++;
      //         let circle = new fabric.Circle({
      //           top: opt.pointer.y - 8,
      //           left: opt.pointer.x - 8,
      //           radius: 8, // 圆的半径 30
      //           fill: "#DBDBDB",
      //           stroke: "#ffffff", // 边框原色
      //           borderColor: "rgba(0,0,0,0)",
      //           strokeWidth: 2, // 边框大小
      //           lockMovementX: true,
      //           lockMovementY: true,
      //           lockScalingX: true,
      //           lockScalingY: true,
      //           partName: "",
      //           partLength: "",
      //           partWidth: "",
      //           partHeight: "",
      //           partMaterial: "",
      //           partTech: "",
      //           pointer: true,
      //           pid: id,
      //         });

      //         circle.setControlsVisibility({
      //           mt: false,
      //           mb: false,
      //           ml: false,
      //           mr: false,
      //           bl: false,
      //           br: false,
      //           tl: false,
      //           tr: false,
      //           mtr: false,
      //         });
      //         circle.hoverCursor = "pointer";
      //         that.handleSetCircleOn(circle);
      //         this.add(circle);
      //         that.$emit("addPart", {
      //           left: opt.pointer.x,
      //           top: opt.pointer.y,
      //           pid: id,
      //         });
      //         this.setActiveObject(circle);
      //       }
      //     }
      //     // 鼠标按下时触发
      //   });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.canvas-box {
  width: 100%;
  height: 100%;
  position: relative;
}

.tip-box {
  position: absolute;
  box-sizing: border-box;
  width: 544px;
  padding: 10px;
  background: #fff;
  opacity: 0.9;
  z-index: 10;
  border-radius: 4px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);

  .content {
    text-align: left;
    .top {
      display: flex;
      .username {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 28px;
        color: #ffb442;
      }

      .text {
        width: 219px;
        height: 27px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 28px;
        color: #606266;
        flex: 1;
      }

      .businessAffirm {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 24px;
        color: #ffb442;
        background: #ffffff;
        border-radius: 20px;
        border: 1px solid #ffb442;
        padding: 7px 12px;
      }
    }
    .info {
      display: inline-block;
      // line-height: 21px;
      line-height: normal;
      margin: 8px 0 18px 0;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 28px;
      color: #303133;
    }

    > div {
      margin-top: 5px;

      &:first-child {
        margin-top: 0;
      }
    }

    .note-info {
      line-height: 21px;
    }

    line-height: normal;
    padding: 0;
    height: 100%;
    margin: 0;
    overflow-y: auto;
    box-sizing: border-box;
    max-height: 358px;

    .circle-title {
      font-weight: 400;
      color: #909399;
    }
  }

  .bot-angle {
    position: absolute;
    content: "";
    top: 100%;
    width: 0;
    left: 18px;
    height: 0;
    border-top: solid 10px #fff;
    border-right: solid 5px transparent;
    border-left: solid 5px transparent;
  }

  .top-angle {
    position: absolute;
    content: "";
    bottom: 100%;
    width: 0;
    left: 18px;
    height: 0;
    border-bottom: solid 10px #fff;
    border-right: solid 5px transparent;
    border-left: solid 5px transparent;
  }
}

.textbox {
  position: absolute;
  z-index: 9;
  // background-color: rgba(255, 255, 255, 0.8);
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.2));
  background-color: #fff;
  opacity: 0.8;

  .el-textarea {
    width: 340px;
    padding-bottom: 20px;

    &::before {
      content: "";
      display: inline-block;
      background: url(../assets/image/shadow-sanjiao.png);
      width: 20px;
      height: 30px;
      position: absolute;
      top: 15px;
      left: -20px;
      z-index: 9;
    }

    ::v-deep .el-textarea__inner {
      // background-color: #fff;
      border: none;
      resize: none;
      min-height: 157px;
      color: #303133;

      &::-webkit-scrollbar {
        display: none;
      }

      // opacity: 0.2;
      // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      // filter: drop-shadow(0 0 4px rgba(0, 0, 0, .2));
    }

    ::v-deep .el-input__count {
      background-color: transparent;
    }
  }

  .save-btn {
    margin-left: -30px;
    z-index: 29;
    color: $base_color;
    /* display: inline-block; */
    position: absolute;
    left: 50px;
    bottom: 10px;
    cursor: pointer;
  }

  .delete-btn {
    margin-left: -30px;
    z-index: 29;
    color: #909399;
    /* display: inline-block; */
    position: absolute;
    left: 100px;
    bottom: 10px;
    cursor: pointer;
  }
}
</style>
